import { FullResourceFragment } from "~/graphql/codegen/graphql";
import { useAnnotatePopoverConfiguration } from "~/components/annotate/hooks/use-annotate-popover-configuration";
import useAnnotationManager from "./hooks/annotation-manager";
import React, { useMemo, useRef } from "react";
import { PDFAnnotatorWrapper } from "./pdf-annotator-wrapper/pdf-annotator-wrapper";
import AnnotateTriviaBar from "~/components/annotate/annotate-trivia-bar";
import { IPdfHighlight, IResourceComment } from "~/typings/annotate/annotation";

export function AnnotateViewPdf({
  article,
}: {
  article: FullResourceFragment;
}) {
  const popoverConfiguration = useAnnotatePopoverConfiguration(article);
  const [comments, highlights] = useAnnotationManager(
    article.id,
    article.annotations,
  );
  const containerRef = useRef<HTMLDivElement>(null);

  // Memoize the annotations object to prevent unnecessary re-renders
  const memoizedAnnotations = useMemo(
    () => ({
      highlights: highlights as IPdfHighlight[],
      comments: comments as IResourceComment[],
    }),
    [highlights, comments],
  );

  return (
    <div
      ref={containerRef}
      className="h-full w-full flex flex-col overflow-hidden px-0 py-4 space-y-4"
    >
      <h2 className="mx-auto text-justify max-w-3xl">{article.headline}</h2>
      <div
        className="w-full h-full overflow-auto"
        style={{
          // Force GPU acceleration and create a new stacking context
          transform: "translateZ(0)",
          willChange: "transform",
        }}
      >
        <PDFAnnotatorWrapper
          id={article.id}
          popoverConfiguration={popoverConfiguration}
          fileUrl={article.fileUrl as string}
          annotations={memoizedAnnotations}
        />
      </div>
      <AnnotateTriviaBar resource={article} />
    </div>
  );
}
